
{
  "cta": "View Full Menu",
  "header": "Try our most popular items",
  "insufficientItems": "This section will only display if there are at least three available popular items with images.",
  "subtitle": "Treat yourself to our must-try list that has everyone talking"
}
